import React from 'react';

import * as S from './styles/LocationPersuasionWithoutPrice.styles';

// COMPONENTS

// ICONS
import OfferIcon from '../../../../../stories/Icons/OfferIcon';

const LoginPersuasionText = () => (
  <div>
    <S.SignUpStaticText>Login & Get</S.SignUpStaticText>
    <S.DealsPersuasionText>The Best Deals & Prices</S.DealsPersuasionText>
  </div>
);

function LoginPersuasionWithoutPrice({onClick}) {
  return (
    <S.Container onClick={onClick}>
      <S.IconWrap>
        <OfferIcon {...S.offerIconProps} />
      </S.IconWrap>
      <LoginPersuasionText />
    </S.Container>
  );
}

export default LoginPersuasionWithoutPrice;
